var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("strong", [
                                  _vm._v("Confirm Availability and Total Rate"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "2", xl: "3" } },
                                [_c("strong", [_vm._v("Total Rate:")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "10", xl: "9" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              attrs: {
                                                row: "",
                                                autocomplete: "",
                                              },
                                              model: {
                                                value: _vm.quoteNotPossible,
                                                callback: function ($$v) {
                                                  _vm.quoteNotPossible = $$v
                                                },
                                                expression: "quoteNotPossible",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label:
                                                    "A quote cannot be given at this time",
                                                  value: 1,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "A quote can be given",
                                                  value: 0,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "12" },
                                        },
                                        _vm._l(
                                          _vm.reservation.units,
                                          function (unit, index) {
                                            return !_vm.quoteNotPossible
                                              ? _c(
                                                  "fieldset",
                                                  [
                                                    _c("legend", [
                                                      _vm._v(
                                                        _vm._s(unit.room.name) +
                                                          " using " +
                                                          _vm._s(
                                                            unit.rate_type.name
                                                          ) +
                                                          ":"
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 ma-0",
                                                        attrs: { cols: "12" },
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v("Guests:"),
                                                        ]),
                                                        _vm._v(
                                                          "  " +
                                                            _vm._s(
                                                              unit.occ_adults
                                                                ? unit.occ_adults +
                                                                    " adults"
                                                                : ""
                                                            ) +
                                                            "\n                                                       " +
                                                            _vm._s(
                                                              unit.occ_oldchildren
                                                                ? unit.occ_oldchildren +
                                                                    " older" +
                                                                    (unit.occ_oldchildren ==
                                                                    1
                                                                      ? " child"
                                                                      : " children")
                                                                : ""
                                                            ) +
                                                            "\n                                                       " +
                                                            _vm._s(
                                                              unit.occ_children
                                                                ? unit.occ_children +
                                                                    (unit.occ_children ==
                                                                    1
                                                                      ? " child"
                                                                      : " children")
                                                                : ""
                                                            ) +
                                                            "\n                                                       " +
                                                            _vm._s(
                                                              unit.occ_babies
                                                                ? unit.occ_babies +
                                                                    (unit.occ_babies ==
                                                                    1
                                                                      ? " baby"
                                                                      : " babies")
                                                                : ""
                                                            ) +
                                                            "\n                                          "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-container",
                                                      { attrs: { fluid: "" } },
                                                      [
                                                        _c(
                                                          "v-layout",
                                                          {
                                                            attrs: { row: "" },
                                                          },
                                                          [
                                                            unit.offer
                                                              ? _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-0",
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "red",
                                                                      },
                                                                    attrs: {
                                                                      cols: "12",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Valid Offer:"
                                                                      ),
                                                                    ]),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          unit
                                                                            .offer
                                                                            .name
                                                                        ) +
                                                                        "\n                                                  "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0 d-none d-sm-flex",
                                                                attrs: {
                                                                  cols: "12",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-container",
                                                                  {
                                                                    attrs: {
                                                                      fluid: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-layout",
                                                                      {
                                                                        attrs: {
                                                                          row: "",
                                                                          wrap: "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "6",
                                                                                sm: "3",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "b",
                                                                              [
                                                                                _vm._v(
                                                                                  "Date"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "12",
                                                                                sm: "2",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "b",
                                                                              [
                                                                                _vm._v(
                                                                                  "Rate (" +
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .reservation
                                                                                        .hotel
                                                                                        .currency
                                                                                        .currency_code
                                                                                    ) +
                                                                                    ")"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " for " +
                                                                                _vm._s(
                                                                                  unit.total_guests
                                                                                ) +
                                                                                " guests\n                                                              "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "6",
                                                                                sm: "2",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "b",
                                                                              [
                                                                                _vm._v(
                                                                                  "Total Daily Rate (" +
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .reservation
                                                                                        .hotel
                                                                                        .currency
                                                                                        .currency_code
                                                                                    ) +
                                                                                    ")"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "6",
                                                                                sm: "2",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "b",
                                                                              [
                                                                                _vm._v(
                                                                                  "Commission Rate (%)"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "6",
                                                                                sm: "3",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "b",
                                                                              [
                                                                                _vm._v(
                                                                                  "Commission Amount (" +
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .reservation
                                                                                        .hotel
                                                                                        .currency
                                                                                        .currency_code
                                                                                    ) +
                                                                                    ")"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              unit.std_rates,
                                                              function (
                                                                quoteDate,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-0",
                                                                    attrs: {
                                                                      cols: "12",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-container",
                                                                      {
                                                                        attrs: {
                                                                          fluid:
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-layout",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                row: "",
                                                                                wrap: "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "ma-0 pa-0",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "12",
                                                                                    sm: "3",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "b",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.dateFormatDDMYYYYDay(
                                                                                          quoteDate.date
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "ma-0 pa-0",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "12",
                                                                                    sm: "2",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-text-field",
                                                                                  {
                                                                                    on: {
                                                                                      keyup:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.updateTotalRatesFromSeparateRates()
                                                                                        },
                                                                                      change:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.updateTotalRatesFromSeparateRates()
                                                                                        },
                                                                                    },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          quoteDate.rate,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              quoteDate,
                                                                                              "rate",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "quoteDate.rate",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "ma-0 pa-0",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "12",
                                                                                    sm: "2",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                  " +
                                                                                    _vm._s(
                                                                                      quoteDate.rate
                                                                                        ? quoteDate.rate
                                                                                        : "-"
                                                                                    ) +
                                                                                    "\n                                                                  "
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "d-md-none",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .reservation
                                                                                          .hotel
                                                                                          .currency
                                                                                          .currency_code
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "ma-0 pa-0",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "12",
                                                                                    sm: "2",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                  " +
                                                                                    _vm._s(
                                                                                      quoteDate.commission
                                                                                    ) +
                                                                                    "% \n                                                                  "
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "d-md-none",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "commission"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "ma-0 pa-0",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "12",
                                                                                    sm: "3",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                  " +
                                                                                    _vm._s(
                                                                                      quoteDate.rate
                                                                                        ? (
                                                                                            (quoteDate.rate /
                                                                                              100) *
                                                                                            quoteDate.commission
                                                                                          ).toFixed(
                                                                                            2
                                                                                          )
                                                                                        : "-"
                                                                                    ) +
                                                                                    "\n                                                              "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  cols: "12",
                                                                  md: "3",
                                                                },
                                                              },
                                                              [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "Total Rate (" +
                                                                      _vm._s(
                                                                        _vm
                                                                          .reservation
                                                                          .hotel
                                                                          .currency
                                                                          .currency_code
                                                                      ) +
                                                                      "):"
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  cols: "12",
                                                                  md: "3",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    staticClass:
                                                                      "text-right align-right",
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateSeparateRatesFromTotalRates()
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.totalRates,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.totalRates =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "totalRates",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("v-col", {
                                                              attrs: {
                                                                cols: "2",
                                                              },
                                                            }),
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                                _c("strong", [_vm._v("Deposit:")]),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "9" } }, [
                                _vm.reservation.depositRequired
                                  ? _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          "Deposit required at time of booking " +
                                            _vm._s(
                                              _vm.reservation.deposit_amount_local.toFixed(
                                                2
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.reservation.hotel.currency
                                                .currency_code
                                            )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.reservation.is_advance_payment
                                  ? _c("div", [
                                      _vm._v(
                                        "Full pre-payment charged to the client by i-escape to secure the booking"
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.reservation.is_advance_payment &&
                                _vm.reservation.type_of_hotel == "UPF" &&
                                _vm.reservation.hotel.collect_deposit == 1
                                  ? _c("div", [
                                      _vm._v(
                                        "Amount charged to the client by i-escape to secure the booking"
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.reservation.is_advance_payment &&
                                _vm.reservation.type_of_hotel == "ARR" &&
                                !_vm.reservation.voucher_key
                                  ? _c("div", [
                                      _vm._v(
                                        "i-escape has not charged the clients card"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                                _c("strong", [_vm._v("Commission:")]),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "9" } }, [
                                _vm._v(
                                  "\n                                      Charged at time of booking " +
                                    _vm._s(
                                      _vm.reservation.commission_amount_local
                                        ? _vm.reservation.commission_amount_local.toFixed(
                                            2
                                          )
                                        : "0.00"
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.reservation.hotel.currency
                                        .currency_code
                                    ) +
                                    "\n                                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                                _c("strong", [_vm._v("Payment Policy:")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "9" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    _vm._l(
                                      _vm.reservation.units,
                                      function (unit) {
                                        return _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(unit.rate_type.name)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  unit.rate_type
                                                    .policy_payment_text
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                                _c("strong", [_vm._v("Cancellation Policy:")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "9" } },
                                _vm._l(_vm.reservation.units, function (unit) {
                                  return _c(
                                    "div",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        _vm._l(
                                          _vm.getCancellationPolicies(
                                            _vm.reservation
                                          ),
                                          function (policy) {
                                            return _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c("div", [
                                                  _c("strong", [
                                                    _vm._v(_vm._s(policy.name)),
                                                  ]),
                                                ]),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: policy.text,
                                                      expression: "policy.text",
                                                    },
                                                  ],
                                                  domProps: {
                                                    value: policy.text,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        policy,
                                                        "text",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.reservation.hotel.is_tailormade_tour
                                        ? "Quote Valid Until"
                                        : "Room Held Until"
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "9" } },
                                [
                                  _c("v-date-picker", {
                                    attrs: { "no-title": "", scrollable: "" },
                                    model: {
                                      value: _vm.reservation.quote_expiry,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.reservation,
                                          "quote_expiry",
                                          $$v
                                        )
                                      },
                                      expression: "reservation.quote_expiry",
                                    },
                                  }),
                                  _vm._v(
                                    " at midnight (GMT)\n                                   "
                                  ),
                                  _c("div", [
                                    _c("strong", [_vm._v("NOTE")]),
                                    _vm._v(
                                      " this shows " +
                                        _vm._s(
                                          _vm.reservation.hotel.holds_rooms
                                        ) +
                                        " days from now. Please change it if you cannot keep the room/s on option for " +
                                        _vm._s(
                                          _vm.reservation.hotel.holds_rooms
                                        ) +
                                        " days. Ensure that you keep the accommodation/service quoted on available for the specified validity period."
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          on: { click: _vm.sendQuote },
                        },
                        [_vm._v("Send to client")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }